<template lang="pug">
  v-container(fill-height)
    v-layout(justify-center align-center)
      .auth-fields.text-center
        a(href="https://simplymotion.de")
          v-img.mx-auto.mb-12(src="@/assets/img/logo_simplymotion_white.png" max-width="300" contain )
        v-card.full-width.elevation-25.pt-2
          v-alert.mx-4(type="error" v-if="error") {{error}}
          v-alert.mx-4(type="info" color="accent").text-left {{$t('auth.activateText')}}
          activate-user-form.ma-4(:submitForm="activateUser" style='flex: 0 1 360px')
        v-btn.text-capitalize.pa-4(text link href="https://simplymotion.de/registrieren/")
          | {{$t('auth.registerText')}}
          v-icon chevron_right

</template>

<script>
import ActivateUserForm from "@/components/user/ActivateUserForm";
export default {
  name: "Login",
  components: {
    ActivateUserForm,
  },
  data() {
    return {
      name: "SIMPLYMOTION",
      error: null,
    };
  },
  methods: {
    async activateUser(loginInfo) {
      this.$store
        .dispatch("auth/ACTIVATE_USER", loginInfo)
        .then(() => {
          console.log("Activating Successfull");
          this.error = null;
        })
        .catch((err) => {
          console.log("Login error", err.message);
          this.error = "Das hat leider nicht geklappt.";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/main";
.auth-fields {
  width: 100%;
  max-width: 500px;
}
</style>
